import { Stack, ToggleButton, ToggleButtonGroup, Typography } from '@mui/material'

import { type DriverUsage } from '../../hooks/useController'
import { useTexts } from '../../useTexts'

interface DriverUsageToggleProps {
  value: DriverUsage
  onChange: (event: React.MouseEvent<HTMLElement>, value: DriverUsage | null) => void
  disabled?: boolean
  /** Only Fleet savings defaults to minimizing drivers, so only it shows the "(Default)" hint. */
  minimizeDriversIsDefault?: boolean
}

export function DriverUsageToggle({
  value,
  onChange,
  disabled = false,
  minimizeDriversIsDefault = false,
}: DriverUsageToggleProps) {
  const texts = useTexts()

  return (
    <Stack spacing={0.5}>
      <Typography variant="caption" color="text.secondary" sx={{ fontSize: '0.75rem' }}>
        {texts.driverUsageLabel}
      </Typography>
      <ToggleButtonGroup
        value={value}
        exclusive
        onChange={onChange}
        disabled={disabled}
        fullWidth
        sx={{
          '& .MuiToggleButton-root': {
            typography: 'body2',
            textTransform: 'none',
            color: t => t.vars.palette.text.secondary,
            '&.Mui-selected': {
              color: t => t.vars.palette.text.secondary,
            },
          },
        }}
      >
        <ToggleButton
          value="minimizeDrivers"
          data-trackid="route-optimization__driver-usage-minimize"
          data-testid="route-optimization__driver-usage-minimize"
        >
          {minimizeDriversIsDefault ? texts.minimizeDriversDefault : texts.minimizeDrivers}
        </ToggleButton>
        <ToggleButton
          value="useAllActiveDrivers"
          data-trackid="route-optimization__driver-usage-all"
          data-testid="route-optimization__driver-usage-all"
        >
          {texts.useAllActiveDrivers}
        </ToggleButton>
      </ToggleButtonGroup>
    </Stack>
  )
}
